import React from 'react'
import { useSelector } from 'react-redux'

import OhBackground from 'components/OhBackground'
import { checklistErrorTypes } from 'constants/checklist'
import { _checklistError } from 'store/selectors/Checklist'

import Checklist from './Checklist'
import CrossSeller from './CrossSeller'
import { Container } from './styles'

const { BLOCK_GROUP_STUDY } = checklistErrorTypes

const PreClass = () => {
    const error = useSelector(_checklistError)
    const background = error === BLOCK_GROUP_STUDY ? 'white' : '#2E2E2E'

    return (
        <OhBackground>
            <Container background={background}>
                <Checklist />
                <CrossSeller />
            </Container>
        </OhBackground>
    )
}

PreClass.propTypes = {}

export default PreClass
